import SquareButton from '../../../../components/SquareButton'
import styled from 'styled-components'
import { useHostFunctions } from '../../hooks/useHostFunctions'
import { Input } from '@galiprandi/react-tools'
import { useSessionParams } from '../../../../hooks/useSessionParams'
import { useState } from 'react'
import { useTimeline } from '../../../../hooks/useTimeline'
import { useZoomContext } from '../../../../context/ZoomContext'
import { useTranslation } from 'react-i18next'
import useParticipants from '../../../../hooks/useParticipants'
import ExpandableBlock from './ExpandableBlock'

const Participants = () => {
    const { t } = useTranslation('sidebar')
    const { enableMic, disableMic } = useHostFunctions()
    const { isHostOrManager } = useZoomContext()
    const { orderedParticipant, hasRaisedHands, findByParticipants } = useParticipants()
    const { room } = useSessionParams()
    const { currentEvent } = useTimeline()
    const { settings } = currentEvent || {}
    const { enabledMic } = settings || {}
    const [searchQuery, setSearchQuery] = useState('')

    const participants = findByParticipants(searchQuery)
    const noResultsMessage = searchQuery !== '' && participants.length === 0 ? t('participants.searchNoResult') : null

    return (
        <ParticipantsStyled>
            <div className="top">
                <div className="search">
                    <Input
                        type="text"
                        name="search"
                        onChangeDebounce={value => setSearchQuery(`${value}`)}
                        value={searchQuery}
                        debounceDelay={800}
                        placeholder={t('participants.searchPlaceholder')}
                        autoComplete="off"
                    />
                    {isHostOrManager && (
                        <SquareButton
                            icon={enabledMic ? ['far', 'microphone'] : ['far', 'microphone-slash']}
                            className={`mics ${enabledMic ? 'mics-enabled' : 'mics-disabled'}`}
                            dark={false}
                            handleClick={enabledMic ? disableMic : enableMic}
                            title={enabledMic ? t('participants.micsEnabled') : t('participants.micsDisabled')}
                        />
                    )}
                </div>
                <div className="participants">
                    {hasRaisedHands.length > 0 && (
                        <ExpandableBlock
                            title={t('participants.raisedHands')}
                            participants={hasRaisedHands}
                            initiallyExpanded={true}
                        />
                    )}

                    <ExpandableBlock
                        title={searchQuery ? t('participants.searchResults') : t('sidebarComp.participants')}
                        participants={participants}
                        initiallyExpanded={true}
                        noResultsMessage={noResultsMessage}
                        isExpandable={false}
                        isSearchBlock
                        searchQuery={searchQuery}
                    />

                    {/* {collaborators.length > 0 && (
                        <ExpandableBlock
                            title={t('participants.collaborators')}
                            participants={collaborators}
                            initiallyExpanded={true}
                        />
                    )} *
                     {isHostOrManager && (
                        <div className="bottom">
                            <PrimaryBtnOutline colorTheme="light" fz="sm" onClick={enabledMic ? disableMic : enableMic}>
                                {enabledMic ? t('participants.muteAll') : t('participants.enableMicrophones')}
                            </PrimaryBtnOutline>
                            <PrimaryBtnOutline
                                colorTheme="light"
                                fz="sm"
                                className="manage-meetings"
                                onClick={() => userId && _classId && signInToAdmin(userId, _classId)}
                            >
                                {t('participants.manageMeetings')}
                            </PrimaryBtnOutline>
                        </div>
                    )} */}
                    {room === 'teams' && (
                        <ExpandableBlock title={t('participants.rest')} participants={orderedParticipant} />
                    )}
                </div>
            </div>
        </ParticipantsStyled>
    )
}

export default Participants

const ParticipantsStyled = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    .participants {
        display: flex;
        flex-direction: column;
        height: auto;
        gap: 10px;
    }
    .top {
        display: flex;
        flex-direction: column;
        flex-grow: 2;

        overflow-y: scroll;
        &::-webkit-scrollbar {
            width: 0; /* Hide the scrollbar */
            background: transparent; /* Optionally, you can set it to transparent */
        }

        .search {
            display: flex;
            margin-bottom: 20px;
            gap: 1em;

            input {
                width: 100%;
                border-radius: 12px;
                border: none;
                background-color: ${props => props.theme.color.sidebar.gray1};
                border: ${props => props.theme.color.sidebar.gray2};
                color: white;
                height: 40px;
                padding: 0 20px;
                box-sizing: border-box;
                margin: 4px 0;
                outline-style: solid;
                outline-color: #444444;
            }

            .mics {
                margin: 0px;
                height: 48px;
                width: 56px;

                &.mics-enabled {
                    background-color: var(--color-active);
                }
                &.mics-disabled {
                    background-color: var(--color-accent);
                }
            }
        }
    }
    .bottom {
        flex: 1;
        display: flex;
        align-items: center;
        max-height: 130px;
        padding: 20px 0 !important;
        padding-bottom: 0 !important;
        gap: 10px;
    }
    .host-buttons {
        display: flex;
        gap: 1em;
        flex-direction: column;
        align-items: center;
        margin-top: 1em;
    }
`
